import script from "./AcceptPolicy.vue?vue&type=script&setup=true&lang=js"
export * from "./AcceptPolicy.vue?vue&type=script&setup=true&lang=js"

import "./AcceptPolicy.vue?vue&type=style&index=0&id=ce93b290&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce93b290"]])

export default __exports__